/**
 * LayoutData — Physical Layouts & International Character Maps
 */

export const layoutPresets = (mainRows, navKeys, navCompactKeys, navArrowKeys, numpadKeys, mainKeysNoFn) => ({
    full: { label: 'FULL', main: mainRows.flat(), nav: navKeys, numpad: numpadKeys },
    tkl: { label: 'TKL', main: mainRows.flat(), nav: navKeys, numpad: [] },
    '75': { label: '75', main: mainRows.flat(), nav: navCompactKeys, numpad: [] },
    '65': { label: '65', main: mainKeysNoFn, nav: navArrowKeys, numpad: [] },
    '60': { label: '60', main: mainKeysNoFn, nav: [], numpad: [] }
});

export const standardLayoutMaps = {
    en: {},
    'en-gb': {
        Digit2: '"', Digit3: '£', Quote: '@', Backquote: '`', Backslash: '#', IntlBackslash: '\\'
    },
    ru: {
        KeyQ: 'Й', KeyW: 'Ц', KeyE: 'У', KeyR: 'К', KeyT: 'Е', KeyY: 'Н', KeyU: 'Г', KeyI: 'Ш', KeyO: 'Щ', KeyP: 'З', BracketLeft: 'Х', BracketRight: 'Ъ',
        KeyA: 'Ф', KeyS: 'Ы', KeyD: 'В', KeyF: 'А', KeyG: 'П', KeyH: 'Р', KeyJ: 'О', KeyK: 'Л', KeyL: 'Д', Semicolon: 'Ж', Quote: 'Э',
        KeyZ: 'Я', KeyX: 'Ч', KeyC: 'С', KeyV: 'М', KeyB: 'И', KeyN: 'Т', KeyM: 'Ь', Comma: 'Б', Period: 'Ю', Slash: '.'
    },
    ko: {
        KeyQ: 'ㅂ', KeyW: 'ㅈ', KeyE: 'ㄷ', KeyR: 'ㄱ', KeyT: 'ㅅ', KeyY: 'ㅛ', KeyU: 'ㅕ', KeyI: 'ㅑ', KeyO: 'ㅐ', KeyP: 'ㅔ',
        KeyA: 'ㅁ', KeyS: 'ㄴ', KeyD: 'ㅇ', KeyF: 'ㄹ', KeyG: 'ㅎ', KeyH: 'ㅗ', KeyJ: 'ㅓ', KeyK: 'ㅏ', KeyL: 'ㅣ',
        KeyZ: 'ㅋ', KeyX: 'ㅌ', KeyC: 'ㅊ', KeyV: 'ㅍ', KeyB: 'ㅠ', KeyN: 'ㅜ', KeyM: 'ㅡ'
    },
    ar: {
        KeyQ: 'ض', KeyW: 'ص', KeyE: 'ث', KeyR: 'ق', KeyT: 'ف', KeyY: 'غ', KeyU: 'ع', KeyI: 'ه', KeyO: 'خ', KeyP: 'ح', BracketLeft: 'ج', BracketRight: 'د',
        KeyA: 'ش', KeyS: 'س', KeyD: 'ي', KeyF: 'ب', KeyG: 'ل', KeyH: 'ا', KeyJ: 'ت', KeyK: 'ن', KeyL: 'م', Semicolon: 'ك', Quote: 'ط',
        KeyZ: 'ئ', KeyX: 'ء', KeyC: 'ؤ', KeyV: 'ر', KeyB: 'لا', KeyN: 'ى', KeyM: 'ة', Comma: 'و', Period: 'ز', Slash: 'ظ'
    },
    ch: {
        KeyY: 'Z', KeyZ: 'Y',
        BracketLeft: 'è', BracketRight: '¨', Semicolon: 'é', Quote: 'à', Backslash: '$',
        Digit1: '1', Digit2: '2', Digit3: '3', Digit4: '4', Digit5: '5', Digit6: '6', Digit7: '7', Digit8: '8', Digit9: '9', Digit0: '0',
        Minus: '\'', Equal: '^'
    },
    'en-azerty': {
        KeyQ: 'A', KeyW: 'Z', KeyE: 'E', KeyR: 'R', KeyT: 'T', KeyY: 'Y', KeyU: 'U', KeyI: 'I', KeyO: 'O', KeyP: 'P',
        KeyA: 'Q', KeyS: 'S', KeyD: 'D', KeyF: 'F', KeyG: 'G', KeyH: 'H', KeyJ: 'J', KeyK: 'K', KeyL: 'L',
        Semicolon: 'M',
        KeyZ: 'W', KeyX: 'X', KeyC: 'C', KeyV: 'V', KeyB: 'B', KeyN: 'N', KeyM: ',',
        Comma: ';', Period: ':', Slash: '!'
    },
    fr: {
        KeyQ: 'A', KeyW: 'Z', KeyE: 'E', KeyR: 'R', KeyT: 'T', KeyY: 'Y', KeyU: 'U', KeyI: 'I', KeyO: 'O', KeyP: 'P',
        KeyA: 'Q', KeyS: 'S', KeyD: 'D', KeyF: 'F', KeyG: 'G', KeyH: 'H', KeyJ: 'J', KeyK: 'K', KeyL: 'L',
        Semicolon: 'M',
        KeyZ: 'W', KeyX: 'X', KeyC: 'C', KeyV: 'V', KeyB: 'B', KeyN: 'N', KeyM: ',',
        Comma: ';', Period: ':', Slash: '!',
        Digit1: '&', Digit2: 'é', Digit3: '"', Digit4: '\'', Digit5: '(', Digit6: '-', Digit7: 'è', Digit8: '_', Digit9: 'ç', Digit0: 'à',
        Minus: ')', Equal: '='
    },
    'en-dvorak': {
        KeyQ: "'", KeyW: ',', KeyE: '.', KeyR: 'P', KeyT: 'Y', KeyY: 'F', KeyU: 'G', KeyI: 'C', KeyO: 'R', KeyP: 'L',
        BracketLeft: '/', BracketRight: '=', Backslash: '\\',
        KeyA: 'A', KeyS: 'O', KeyD: 'E', KeyF: 'U', KeyG: 'I', KeyH: 'D', KeyJ: 'H', KeyK: 'T', KeyL: 'N',
        Semicolon: 'S', Quote: '-',
        KeyZ: ';', KeyX: 'Q', KeyC: 'J', KeyV: 'K', KeyB: 'X', KeyN: 'B', KeyM: 'M',
        Comma: 'W', Period: 'V', Slash: 'Z'
    },
    de: {
        KeyY: 'Z', KeyZ: 'Y',
        BracketLeft: 'Ü', BracketRight: '+',
        Semicolon: 'Ö', Quote: 'Ä',
        Backslash: '#',
        Digit1: '1', Digit2: '2', Digit3: '3', Digit4: '4', Digit5: '5', Digit6: '6', Digit7: '7', Digit8: '8', Digit9: '9', Digit0: '0',
        Minus: 'ß', Equal: '´'
    },
    es: {
        Semicolon: 'Ñ', Quote: '´', BracketLeft: '`', BracketRight: '+', Backslash: 'Ç', Slash: '-',
        Digit1: '1', Digit2: '2', Digit3: '3', Digit4: '4', Digit5: '5', Digit6: '6', Digit7: '7', Digit8: '8', Digit9: '9', Digit0: '0',
        Minus: '?', Equal: '¿'
    },
    it: {
        BracketLeft: 'è', BracketRight: '+', Semicolon: 'ò', Quote: 'à', Backslash: 'ù', Slash: '-',
        Digit1: '1', Digit2: '2', Digit3: '3', Digit4: '4', Digit5: '5', Digit6: '6', Digit7: '7', Digit8: '8', Digit9: '9', Digit0: '0',
        Minus: '\'', Equal: 'ì'
    },
    'pt-br': {
        BracketLeft: '´', BracketRight: '[', Semicolon: 'Ç', Quote: '~', Backslash: ']', Slash: ';',
        IntlRo: '/',
        Digit1: '1', Digit2: '2', Digit3: '3', Digit4: '4', Digit5: '5', Digit6: '6', Digit7: '7', Digit8: '8', Digit9: '9', Digit0: '0'
    },
    tr: {
        BracketLeft: 'Ğ', BracketRight: 'Ü', Semicolon: 'Ş', Quote: 'İ', Comma: 'Ö', Period: 'Ç', Slash: '.',
        Digit1: '1', Digit2: '2', Digit3: '3', Digit4: '4', Digit5: '5', Digit6: '6', Digit7: '7', Digit8: '8', Digit9: '9', Digit0: '0',
        Minus: '*', Equal: '-'
    },
    uk: {
        KeyQ: 'Й', KeyW: 'Ц', KeyE: 'У', KeyR: 'К', KeyT: 'Е', KeyY: 'Н', KeyU: 'Г', KeyI: 'Ш', KeyO: 'Щ', KeyP: 'З', BracketLeft: 'Х', BracketRight: 'Ї', Backslash: 'Ґ',
        KeyA: 'Ф', KeyS: 'І', KeyD: 'В', KeyF: 'А', KeyG: 'П', KeyH: 'Р', KeyJ: 'О', KeyK: 'Л', KeyL: 'Д', Semicolon: 'Ж', Quote: 'Є',
        KeyZ: 'Я', KeyX: 'Ч', KeyC: 'С', KeyV: 'М', KeyB: 'И', KeyN: 'Т', KeyM: 'Ь', Comma: 'Б', Period: 'Ю', Slash: '.'
    },
    pl: {},
    nl: {},
    'se': { // Swedish/Finnish
        BracketLeft: 'Å', BracketRight: '¨', Semicolon: 'Ö', Quote: 'Ä', Backslash: '\'', Slash: '-',
        Digit1: '1', Digit2: '2', Digit3: '3', Digit4: '4', Digit5: '5', Digit6: '6', Digit7: '7', Digit8: '8', Digit9: '9', Digit0: '0',
        Minus: '+', Equal: '´'
    },
    'no': { // Norwegian/Danish
        BracketLeft: 'Å', BracketRight: '¨', Semicolon: 'Ø', Quote: 'Æ', Backslash: '\'', Slash: '-',
        Digit1: '1', Digit2: '2', Digit3: '3', Digit4: '4', Digit5: '5', Digit6: '6', Digit7: '7', Digit8: '8', Digit9: '9', Digit0: '0',
        Minus: '+', Equal: '´'
    }
};

export const getMainRows = (layoutType = 'ANSI') => {
    const isISO = layoutType === 'ISO';
    const isJIS = layoutType === 'JIS';

    const rows = [
        // Row 1 (Function Row)
        [
            { code: 'Escape', label: 'ESC', span: 1, row: 1 },
            { type: 'spacer', span: 1, row: 1 },
            { code: 'F1', label: 'F1', span: 1, row: 1 }, { code: 'F2', label: 'F2', span: 1, row: 1 }, { code: 'F3', label: 'F3', span: 1, row: 1 }, { code: 'F4', label: 'F4', span: 1, row: 1 },
            { type: 'spacer', span: 0.5, row: 1 },
            { code: 'F5', label: 'F5', span: 1, row: 1 }, { code: 'F6', label: 'F6', span: 1, row: 1 }, { code: 'F7', label: 'F7', span: 1, row: 1 }, { code: 'F8', label: 'F8', span: 1, row: 1 },
            { type: 'spacer', span: 0.5, row: 1 },
            { code: 'F9', label: 'F9', span: 1, row: 1 }, { code: 'F10', label: 'F10', span: 1, row: 1 }, { code: 'F11', label: 'F11', span: 1, row: 1 }, { code: 'F12', label: 'F12', span: 1, row: 1 },
        ],

        // Row 2 (Numbers)
        [
            { code: 'Backquote', label: '`', span: 1, row: 2 },
            { code: 'Digit1', label: '1', span: 1, row: 2 }, { code: 'Digit2', label: '2', span: 1, row: 2 }, { code: 'Digit3', label: '3', span: 1, row: 2 }, { code: 'Digit4', label: '4', span: 1, row: 2 }, { code: 'Digit5', label: '5', span: 1, row: 2 }, { code: 'Digit6', label: '6', span: 1, row: 2 }, { code: 'Digit7', label: '7', span: 1, row: 2 }, { code: 'Digit8', label: '8', span: 1, row: 2 }, { code: 'Digit9', label: '9', span: 1, row: 2 }, { code: 'Digit0', label: '0', span: 1, row: 2 },
            { code: 'Minus', label: '-', span: 1, row: 2 },
            { code: 'Equal', label: '=', span: 1.0, row: 2 },
            ...(isJIS ? [
                { code: 'IntlYen', label: '¥', span: 1.0, row: 2 },
                { code: 'Backspace', label: 'BKSP', labelMac: 'DEL', span: 1, row: 2 }
            ] : [
                { code: 'Backspace', label: 'BKSP', labelMac: 'DEL', span: 2, row: 2 }
            ]),
        ],

        // Row 3 (QWERTY)
        [
            { code: 'Tab', label: 'TAB', span: 1.5, row: 3 },
            { code: 'KeyQ', label: 'Q', span: 1, row: 3 }, { code: 'KeyW', label: 'W', span: 1, row: 3 }, { code: 'KeyE', label: 'E', span: 1, row: 3 }, { code: 'KeyR', label: 'R', span: 1, row: 3 }, { code: 'KeyT', label: 'T', span: 1, row: 3 }, { code: 'KeyY', label: 'Y', span: 1, row: 3 }, { code: 'KeyU', label: 'U', span: 1, row: 3 }, { code: 'KeyI', label: 'I', span: 1, row: 3 }, { code: 'KeyO', label: 'O', span: 1, row: 3 }, { code: 'KeyP', label: 'P', span: 1, row: 3 },
            { code: 'BracketLeft', label: '[', span: 1, row: 3 },
            { code: 'BracketRight', label: ']', span: 1, row: 3 },
            ...(isISO || isJIS ? [
                { code: 'Enter', label: 'ENTER', labelMac: 'RETURN', span: 1.5, row: 3, rowSpan: 2 }
            ] : [
                { code: 'Backslash', label: '\\', span: 1.5, row: 3 }
            ])
        ],

        // Row 4 (ASDF)
        [
            { code: 'CapsLock', label: 'CAPS', span: 1.75, row: 4 },
            { code: 'KeyA', label: 'A', span: 1, row: 4 }, { code: 'KeyS', label: 'S', span: 1, row: 4 }, { code: 'KeyD', label: 'D', span: 1, row: 4 }, { code: 'KeyF', label: 'F', span: 1, row: 4 }, { code: 'KeyG', label: 'G', span: 1, row: 4 }, { code: 'KeyH', label: 'H', span: 1, row: 4 }, { code: 'KeyJ', label: 'J', span: 1, row: 4 }, { code: 'KeyK', label: 'K', span: 1, row: 4 }, { code: 'KeyL', label: 'L', span: 1, row: 4 },
            { code: 'Semicolon', label: ';', span: 1, row: 4 },
            { code: 'Quote', label: '\'', span: 1, row: 4 },
            ...(isISO || isJIS ? [
                { code: 'Backslash', label: '#', span: 1, row: 4 } // For ISO, this key is here
            ] : [
                { code: 'Enter', label: 'ENTER', labelMac: 'RETURN', span: 2.25, row: 4 }
            ])
        ],

        // Row 5 (ZXCV)
        [
            { code: 'ShiftLeft', label: 'SHIFT', span: (isISO || isJIS) ? 1.25 : 2.25, row: 5 },
            ...(isISO || isJIS ? [{ code: 'IntlBackslash', label: '\\', span: 1, row: 5 }] : []),
            { code: 'KeyZ', label: 'Z', span: 1, row: 5 }, { code: 'KeyX', label: 'X', span: 1, row: 5 }, { code: 'KeyC', label: 'C', span: 1, row: 5 }, { code: 'KeyV', label: 'V', span: 1, row: 5 }, { code: 'KeyB', label: 'B', span: 1, row: 5 }, { code: 'KeyN', label: 'N', span: 1, row: 5 }, { code: 'KeyM', label: 'M', span: 1, row: 5 },
            { code: 'Comma', label: ',', span: 1, row: 5 },
            { code: 'Period', label: '.', span: 1, row: 5 },
            { code: 'Slash', label: '/', span: 1, row: 5 },
            ...(isJIS ? [{ code: 'IntlRo', label: '_', span: 1, row: 5 }] : []),
            { code: 'ShiftRight', label: 'SHIFT', span: (isJIS) ? 1.75 : 2.75, row: 5 }, // JIS Right Shift is smaller
        ],

        // Row 6 (Bottom Row)
        [
            { code: 'ControlLeft', label: 'CTRL', span: 1.25, row: 6 },
            { code: 'MetaLeft', label: 'WIN', labelWin: 'WIN', labelMac: 'CMD', span: 1.25, row: 6 },
            { code: 'AltLeft', label: 'ALT', labelWin: 'ALT', labelMac: 'OPT', span: 1.25, row: 6 },
            ...(isJIS ? [
                { code: 'Muhenkan', label: '無変換', span: 1, row: 6 },
                { code: 'Space', label: 'SPACE', span: 3.25, row: 6 },
                { code: 'Henkan', label: '変換', span: 1, row: 6 },
                { code: 'HiraganaKatakana', label: 'ひらがな', span: 1, row: 6 }
            ] : [
                { code: 'Space', label: 'SPACE', span: 6.25, row: 6 }
            ]),
            { code: 'AltRight', label: (isJIS) ? 'ALT' : 'ALT', labelWin: 'ALT', labelMac: 'OPT', span: 1.25, row: 6 },
            ...(isJIS ? [] : [{ code: 'MetaRight', label: 'WIN', labelWin: 'WIN', labelMac: 'CMD', span: 1.25, row: 6 }]),
            { code: 'ContextMenu', label: 'MENU', labelMac: 'FN', span: 1.25, row: 6 },
            { code: 'ControlRight', label: 'CTRL', span: 1.25, row: 6 }
        ]
    ];
    return rows;
};

export const getNavKeys = () => [
    { code: 'PrintScreen', label: 'PRT', span: 1 }, { code: 'ScrollLock', label: 'SCR', span: 1 }, { code: 'Pause', label: 'PAU', span: 1 },
    { code: 'Insert', label: 'INS', span: 1 }, { code: 'Home', label: 'HM', span: 1 }, { code: 'PageUp', label: 'PU', span: 1 },
    { code: 'Delete', label: 'DEL', span: 1 }, { code: 'End', label: 'END', span: 1 }, { code: 'PageDown', label: 'PD', span: 1 },
    { type: 'spacer', span: 3 },
    { type: 'spacer', span: 1 }, { code: 'ArrowUp', label: 'UP', span: 1 }, { type: 'spacer', span: 1 },
    { code: 'ArrowLeft', label: 'LEFT', span: 1 }, { code: 'ArrowDown', label: 'DOWN', span: 1 }, { code: 'ArrowRight', label: 'RIGHT', span: 1 }
];

export const numpadKeys = [
    { type: 'spacer', span: 4 },
    { code: 'NumLock', label: 'NL', span: 1 }, { code: 'NumpadDivide', label: '/', span: 1 }, { code: 'NumpadMultiply', label: '*', span: 1 }, { code: 'NumpadSubtract', label: '-', span: 1 },
    { code: 'Numpad7', label: '7', span: 1 }, { code: 'Numpad8', label: '8', span: 1 }, { code: 'Numpad9', label: '9', span: 1 }, { code: 'NumpadAdd', label: '+', span: 1, rowSpan: 2 },
    { code: 'Numpad4', label: '4', span: 1 }, { code: 'Numpad5', label: '5', span: 1 }, { code: 'Numpad6', label: '6', span: 1 },
    { code: 'Numpad1', label: '1', span: 1 }, { code: 'Numpad2', label: '2', span: 1 }, { code: 'Numpad3', label: '3', span: 1 }, { code: 'NumpadEnter', label: 'ENT', span: 1, rowSpan: 2 },
    { code: 'Numpad0', label: '0', span: 2 }, { code: 'NumpadDecimal', label: '.', span: 1 }
];
